// Angular and Core
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

// Shared
import { BlockableDivModule } from '../shared/components/blockable-div/blockable-div.module';
import { LanguageDialogModule } from '../shared/components/language/language.dialog.module';
import { SharedModule } from '../shared/shared.module';
import { DevicesVctListComponent } from './devices-vct-list/devices-vct-list.component';
import { TreeTableModule } from 'primeng/treetable';
import { TreeModule } from 'primeng/tree';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { ShareDeviceVctDialogComponent } from './share-device-vct-dialog/share-device-vct.dialog.component';
import { InputTextModule } from 'primeng/inputtext';
import { EditDeviceVctDialogComponent } from './edit-device-vct-dialog/edit-device-vct.dialog.component';
import { AuxConfigDeviceVctDialogComponent } from './aux-config-device-vct-dialog/aux-config-device-vct.dialog.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { EditUnitVctDialogComponent } from './edit-unit-vct-dialog/edit-unit-vct.dialog.component';
import { EditOperatorsVctDialogComponent } from './edit-operators-vct-dialog copy/edit-operators-vct.dialog.component';
import { EditIntercommunicatingVctDialogComponent } from './edit-intercommunicating-vct-dialog/edit-intercommunicating-vct.dialog.component';
import { DeviceVctListFiltersComponent } from './devices-vct-list/devices-vct-list-filters.component';
import { DeviceVctListEditFiltersComponent } from './devices-vct-list-edit/devices-vct-list-edit-filters.component';
import { DevicesVctListEditComponent } from './devices-vct-list-edit/devices-vct-list-edit.component';
import { ShareDeviceVctUploadDialogComponent } from './share-device-vct-upload-dialog/share-device-vct-upload.dialog.component';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ScrollerModule } from 'primeng/scroller';
import { CheckboxModule } from 'primeng/checkbox';

// Primeng modules

// Components


@NgModule({
    declarations: [
        DevicesVctListComponent,
        ShareDeviceVctDialogComponent,
        EditDeviceVctDialogComponent,
        EditUnitVctDialogComponent,
        AuxConfigDeviceVctDialogComponent,
        EditOperatorsVctDialogComponent,
        EditIntercommunicatingVctDialogComponent,
        DeviceVctListFiltersComponent,
        DeviceVctListEditFiltersComponent,
        DevicesVctListEditComponent,
        ShareDeviceVctUploadDialogComponent
    ],
    imports: [
        BlockableDivModule,
        CommonModule,
        FormsModule,
        LanguageDialogModule,
        ReactiveFormsModule,
        RouterModule,
        SharedModule,
        TranslateModule,
        TreeModule,
        TreeTableModule,
        TagModule,
        TooltipModule,
        InputTextModule,
        InputSwitchModule,
        FileUploadModule,
        InputTextareaModule,
        ProgressSpinnerModule,
        ScrollerModule,
        CheckboxModule,
    ],
    exports: [
        DevicesVctListComponent,
        ShareDeviceVctDialogComponent,
        EditDeviceVctDialogComponent,
        EditUnitVctDialogComponent,
        AuxConfigDeviceVctDialogComponent,
        EditOperatorsVctDialogComponent,
        EditIntercommunicatingVctDialogComponent,
        DeviceVctListFiltersComponent,
        DeviceVctListEditFiltersComponent,
        DevicesVctListEditComponent,
        ShareDeviceVctUploadDialogComponent,
    ]
})
export class DevicesVctModule { }
